import { GROUP_MEMBERSHIPS } from '../../constants/abbreviations';

export default {
    formatGroupMembershipsPartnerName: (partnerName) => {
        return partnerName ? `${partnerName} - ${GROUP_MEMBERSHIPS}` : GROUP_MEMBERSHIPS;
    }
};